/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { authClusterCreateInvite } from "../../funcs/authClusterCreateInvite.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.CreateClusterInviteRequest$inboundSchema,
};

export const tool$authClusterCreateInvite: ToolDefinition<typeof args> = {
  name: "auth-cluster-create-invite",
  description: `Create a cluster invitation

Issue a one-shot invite that provisions a new org on acceptance. Email-bound invites can be accepted headless (passwordless + issueApiKey).`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await authClusterCreateInvite(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
